import { mapUrlToPageLogProps, Page } from 'components/Logs'

export default {
  Logs: mapUrlToPageLogProps(({ params }) => ({
    title: 'Processamento',
    entity: 'order',
    entityId: params.orderId,
  }))(Page),
}
